import { render } from "./PageHeader.vue?vue&type=template&id=76a8c0b2"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
script.render = render

export default script